import { render } from "./DeviationSearchPathTable.vue?vue&type=template&id=148c8112"
import script from "./DeviationSearchPathTable.vue?vue&type=script&lang=ts"
export * from "./DeviationSearchPathTable.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
